/**
 * Documento de identidad del cliente: cédula, RNC o pasaporte.
 *
 * Los tres se guardan en la misma columna `cedula` varchar(15) (el
 * escritorio ares escribe en las mismas tablas, así que no hay columna
 * de tipo). El tipo se deriva del valor: 11 dígitos = cédula,
 * 9 dígitos = RNC, con letras = pasaporte.
 */

export const TIPOS_DOCUMENTO = [
  { value: "cedula", label: "Cédula" },
  { value: "rnc", label: "RNC" },
  { value: "pasaporte", label: "Pasaporte" },
];

// Formatea según el tipo elegido (progresivo mientras se escribe).
// Cédula: 000-0000000-0 · RNC: 000-00000-0 · Pasaporte: alfanumérico en mayúsculas.
export const formatDocumento = (v, tipo = "cedula") => {
  if (tipo === "pasaporte") {
    return String(v || "").replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, 15);
  }
  const d = String(v || "").replace(/\D/g, "");
  if (tipo === "rnc") {
    const r = d.slice(0, 9);
    const p1 = r.slice(0, 3);
    const p2 = r.slice(3, 8);
    const p3 = r.slice(8, 9);
    let out = p1;
    if (p2) out += "-" + p2;
    if (p3) out += "-" + p3;
    return out;
  }
  const c = d.slice(0, 11);
  const p1 = c.slice(0, 3);
  const p2 = c.slice(3, 10);
  const p3 = c.slice(10, 11);
  let out = p1;
  if (p2) out += "-" + p2;
  if (p3) out += "-" + p3;
  return out;
};

export const placeholderDocumento = (tipo = "cedula") =>
  tipo === "rnc" ? "000-00000-0" : tipo === "pasaporte" ? "A0000000" : "000-0000000-0";

export const maxLengthDocumento = (tipo = "cedula") =>
  tipo === "rnc" ? 11 : tipo === "cedula" ? 13 : 15;

// true si el valor está completo para el tipo (cédula 11 dígitos,
// RNC 9 dígitos, pasaporte 6+ caracteres).
export const documentoValido = (v, tipo = "cedula") => {
  const s = String(v || "").trim();
  if (tipo === "pasaporte") return s.length >= 6;
  const d = s.replace(/\D/g, "");
  return tipo === "rnc" ? d.length === 9 : d.length === 11;
};

// Deriva el tipo desde un valor ya guardado.
export const tipoDocumento = (v) => {
  const s = String(v || "").trim();
  if (!s) return "cedula";
  if (/[a-zA-Z]/.test(s)) return "pasaporte";
  const d = s.replace(/\D/g, "");
  return d.length === 9 ? "rnc" : "cedula";
};

export const etiquetaDocumento = (v) => {
  const t = tipoDocumento(v);
  return t === "rnc" ? "RNC" : t === "pasaporte" ? "Pasaporte" : "Cédula";
};

// Re-aplica la máscara del tipo derivado a un valor guardado (para mostrar).
export const formatDocumentoAuto = (v) => formatDocumento(v, tipoDocumento(v));
